module.exports = __webpack_public_path__ + "static/media/icon_heart.72b6fed2.svg";